import { PortalAuthHttpError } from '../error';
import { PortalApiClient } from '../portalApiClient';

import { getMessageFromError } from './errorHelper';

export async function resetPassword(email: string, client: PortalApiClient) {
  try {
    const { data, error, response } = await client.untyped.POST(
      '/api/v1/users/password',
      {
        body: { email },
      }
    );
    if (!response.ok) {
      const message = getMessageFromError(error);
      throw new PortalAuthHttpError(
        message ?? 'Reset password failed.',
        response.status
      );
    }
    return data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
